import HighwayTransition from '@dogstudio/highway/src/transition';
import nextFrame from '@studiometa/js-toolkit/utils/nextFrame';

/**
 * Use highway Transition
 * @param object app The JS Toolkit app.
 */
export default function useTransition(app) {
  /**
   * Highway transition
   */
  return class Transition extends HighwayTransition {
    /**
     * In
     * @param object param0 In params.
     */
    async in({ from, done }) {
      // Reset Scroll
      window.scroll(0, 0);

      // Remove Old View
      from.remove();

      // Update JS Toolkit App components
      app.$update();

      await nextFrame();
      await nextFrame();

      // Run animation
      app.loaderInstance.animateIn(done);
    }

    /**
     * Out
     */
    async out({ done }) {
      // Run animation
      app.loaderInstance.animateOut(done);
    }
  };
}
